import { ChangeDetectionStrategy, Component, EventEmitter, HostBinding, Input, Output } from '@angular/core';
import { ManageAddressService } from '@woolworthsnz/fulfilment';
import { ButtonComponent, NotificationType, TrackingEvent } from '@woolworthsnz/styleguide';
import { Address } from '@woolworthsnz/trader-api';
import { NgFor, NgIf } from '@angular/common';

@Component({
	selector: 'account-existing-address, [accountExistingAddress]',
	template: `
		<div class="existingAddress">
			<address>
				<ng-container *ngFor="let a of formattedAddress; let first = first; let last = last">
					<strong *ngIf="first; else normalText">{{ a }}</strong>
					<ng-template #normalText>{{ a }}</ng-template>

					<br *ngIf="!last" />
				</ng-container>
			</address>
			<button
				cdxButton
				[inline]="true"
				*ngIf="!isPrimary && !isChangingOrder"
				fillStyle="warnOutline"
				(click)="delete.emit(address.externalAddressId)"
				i18n="@@existingAddress-deleteBtn"
			>
				Delete
			</button>
		</div>
	`,
	styleUrls: ['./existing-address.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush,
	standalone: true,
	imports: [NgFor, NgIf, ButtonComponent]
})
export class ExistingAddressComponent {
	@Input() isPrimary: boolean;

	@Input() isChangingOrder: boolean;

	@Output() delete = new EventEmitter<string>();

	@HostBinding('class.isEditMode') isEditMode = false;

	trackingEvent = TrackingEvent;
	notificationType = NotificationType;
	private _formattedAddress: string[];
	private _address: Address;

	constructor(public manageAddressService: ManageAddressService) { }

	get address(): Address {
		return this._address;
	}

	get formattedAddress(): string[] {
		return this._formattedAddress;
	}

	@Input() set address(a: Address) {
		this._address = a;
		this._formattedAddress = this.manageAddressService.buildAddress(a);
	}

	deleteAddress(): void {
		this.manageAddressService.deleteAddress(this.address.externalAddressId || '');
	}

	hideEditMode(): void {
		this.isEditMode = false;
	}

	showEditMode(): void {
		this.isEditMode = true;
	}
}
